// Model
import { components34Names } from './components.enum';
// Component
import { RoomLayoutComponent } from '../../../components/common/room-layout/room-layout.component';
import { TabsSectionComponent } from '../../../components/common/tabs-section/tabs-section.component';
import { DynamicHtmlComponent } from '../../../components/common/dynamic-html/dynamic-html.component';
import { RoomRulesDesign } from '../../../components/models/component-options/inline-rules.options';
import { InlineRulesComponent } from '../../../components/common/inline-rules/inline-rules.component';
import { MapLocationComponent } from '../../../components/common/map-location/map-location.component';
import { PanoramaTourComponent } from '../../../components/common/panorama-tour/panorama-tour.component';
import { PhotoGalleryComponent } from '../../../components/common/photo-gallery/photo-gallery.component';
import { PhotoListSelectedComponent } from '../../../components/common/photo-list-selected/photo-list-selected.component';
import { ResourceMediaControlComponent } from '../../../components/common/resource-media-control/resource-media-control.component';
import { SingleImageComponent } from '../../../components/common/single-image/single-image.component';
import { DynamicFieldsSectionComponent } from '../../../components/common/dynamic-fields-section/dynamic-fields-section.component';

export const layout34Components = {
	[components34Names.ROOM_LAYOUT]: RoomLayoutComponent,
	[components34Names.TABS_SECTION]: TabsSectionComponent,
	[components34Names.HTML_NODE]: DynamicHtmlComponent,
	[components34Names.FIELDS_SECTION]: DynamicFieldsSectionComponent,
	[components34Names.MAP]: MapLocationComponent,
	[components34Names.RULES]: InlineRulesComponent,
	[components34Names.PANORAMA_TOUR]: PanoramaTourComponent,
	[components34Names.RESOURCE_MEDIA]: ResourceMediaControlComponent,
	[components34Names.PHOTO_GALLERY]: PhotoGalleryComponent,
	[components34Names.PHOTO_SELECTED]: PhotoListSelectedComponent,
	[components34Names.SINGLE_IMAGE]: SingleImageComponent
};

export const layout34 = {
	map: {
		type: components34Names.ROOM_LAYOUT,
		options: {
			header: {
				value: 'Property Data'
			}
		},
		items: [
			{
				type: components34Names.MAP,
			}
		]
	},
	addressVerification: {
		type: components34Names.ROOM_LAYOUT,
		options: {
			schemaVersion: 'v34',
			cssClass: 'natural-height',
			bodyCssClass: 'py-2',
			header: {
				value: 'Address Verification'
			}
		},
		items: [
			{
				type: 'inline-rules',
				options: {
					layout: RoomRulesDesign.INLINE // @see RoomRulesDesign
				}
			},
			{
				title: 'Report Images',
				type: components34Names.PHOTO_GALLERY,
				options: {
					photosInData: false,
					showDescription: true,
					renderTemplate: {
						rendererKey: 'tagType'
					},
					size: {
						width: '469px',
						height: '350px'
					},
				}
			},
			// {
			//     type: components34Names.SINGLE_IMAGE,
			//     options: {
			//         cssClass: 'h-100',
			//         key: '_Path',
			//         filter: [
			//             {
			//                 key: 'metadata.imageType',
			//                 value: 'gla'
			//             }
			//         ]
			//     }
			// }
		]
	},
	room: {
		type: components34Names.ROOM_LAYOUT,
		options: {
			header: {
				key: 'description' // deafult value
			},
			cssClass: 'v34',
		},
		items: [
			{
				type: components34Names.RESOURCE_MEDIA,
				options: {}
			},
			{
				type: components34Names.TABS_SECTION,
				options: {
					cssClass: 'tabs-container'
				},
				items: [
					{
						title: 'Report Images',
						type: components34Names.PHOTO_GALLERY,
						options: {
							showDescription: true,
							filter: ['HDR'],
							readDescriptionFromData: {
								key: [
									'description',
									'roomId'
								]
							},
							size: {
								width: '469px',
								height: '350px'
							},
						}
					},
					{
						title: '3d Tour',
						type: components34Names.PANORAMA_TOUR,
						options: {
							filter: ['EQUIRECTANGULAR'],
							readDescriptionFromData: {
								key: [
									'description',
									'roomId'
								]
							}
						}
					},
					{
						title: 'Assets',
						type: components34Names.PHOTO_GALLERY,
						options: {
							key: 'smartTags.assets',
							showDescription: true,
							renderTemplate: {
								rendererKey: 'tagType'
							},
							size: {
								width: '469px',
								height: '350px'
							},
						}
					},
					{
						title: 'Features',
						type: components34Names.PHOTO_GALLERY,
						options: {
							key: 'smartTags.features',
							showDescription: true,
							renderTemplate: {
								rendererKey: 'tagType'
							},
							size: {
								width: '469px',
								height: '350px'
							},
						}
					},
					{
						title: 'Views',
						type: components34Names.PHOTO_GALLERY,
						options: {
							key: 'smartTags.views',
							showDescription: true,
							renderTemplate: {
								rendererKey: 'tagType'
							},
							size: {
								width: '469px',
								height: '350px'
							},
						}
					},
					{
						title: 'Conditions',
						type: components34Names.PHOTO_GALLERY,
						options: {
							key: 'smartTags.conditions',
							showDescription: true,
							renderTemplate: {
								rendererKey: 'tagType'
							},
							size: {
								width: '469px',
								height: '350px'
							},
						}
					},
					{
						title: 'Others',
						type: components34Names.PHOTO_GALLERY,
						options: {
							key: 'smartTags.others',
							showDescription: true,
							renderTemplate: {
								rendererKey: 'tagType'
							},
							size: {
								width: '469px',
								height: '350px'
							},
						}
					},
					{
						title: 'Custom',
						type: components34Names.PHOTO_GALLERY,
						options: {
							key: 'smartTags.custom',
							showDescription: true,
							renderTemplate: {
								rendererKey: 'tagType'
							},
							size: {
								width: '469px',
								height: '350px'
							},
						}
					},
					{
						title: 'Selected Photos',
						type: components34Names.PHOTO_SELECTED,
						options: {
						}
					},
				]
			},
			{
				type: 'inline-rules',
				options: {
					layout: RoomRulesDesign.INLINE // @see RoomRulesDesign
				}
			}
		]
	}
};
